export enum InputType {
  Text = 'text',
  Email = 'email',
  Password = 'password',
  Number = 'number',
  Checkbox = 'checkbox',
  Radio = 'radio',
  File = 'file',
  Date = 'date',
  Time = 'time'
}